import script from "./ItemDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./ItemDetails.vue?vue&type=script&setup=true&lang=js"

import "./ItemDetails.vue?vue&type=style&index=0&id=5d69bfc9&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d69bfc9"]])

export default __exports__